import React from 'react';
import './dotsSpinner.scss';

export default function DotsSpinner() {
    return (
        <div className="loader">Loading...</div>
    )
}
